var AT_Slider={owlSlider:function(){AT_Main.getWidthBrowser()<992?jQuery(document).on("click",".mega-menu",function(s){jQuery(".mega-menu.menu-mobile-open .menu-proudct-carousel").length&&jQuery(".mega-menu.menu-mobile-open .menu-proudct-carousel").owlCarousel({loop:!1,nav:!0,dots:!1,items:1,navText:['<span class="button-prev"></span>','<span class="button-next"></span>']})}):jQuery(".menu-proudct-carousel").length&&jQuery(".menu-proudct-carousel").owlCarousel({loop:!1,nav:!0,dots:!1,items:1,navText:['<span class="button-prev"></span>','<span class="button-next"></span>']}),jQuery(".post-list-slider").length&&jQuery(".post-list-slider").owlCarousel({loop:!1,nav:!0,dots:!1,items:3,margin:30,responsive:{0:{items:1},480:{items:2},992:{items:3}},navText:['<span class="button-prev"></span>','<span class="button-next"></span>']}),jQuery(".policy-list").length&&jQuery(".policy-list").owlCarousel({nav:!1,dots:!1,items:5,responsive:{0:{items:1},480:{items:2},768:{items:3},992:{items:4},1024:{items:5}}}),jQuery(".image-carousel").length&&jQuery(".image-carousel").owlCarousel({nav:!0,dots:!1,items:1,navText:['<span class="button-prev"></span>','<span class="button-next"></span>']}),jQuery(".catalog-list").length&&jQuery(".catalog-list").owlCarousel({nav:!0,dots:!1,items:3,margin:30,responsive:{0:{items:1},480:{items:2},992:{items:3,nav:!1}},navText:['<span class="button-prev"></span>','<span class="button-next"></span>']}),jQuery(".gallery-image-thumb").length&&jQuery(".gallery-image-thumb").owlCarousel({nav:!0,dots:!1,margin:20,mouseDrag:!1,responsive:{0:{items:2},480:{items:3},768:{items:4}},navText:['<span class="button-prev"></span>','<span class="button-next"></span>']}),jQuery(".bottom-partner-carousel").length&&jQuery(".bottom-partner-carousel").owlCarousel({nav:!0,dots:!1,margin:30,responsive:{0:{items:2},480:{items:3},768:{items:4},992:{items:5}},navText:['<span class="button-prev"></span>','<span class="button-next"></span>']}),jQuery(".type-testimonial .testimonial").length&&jQuery(".type-testimonial .testimonial").owlCarousel({nav:!0,dots:!1,items:1,navText:['<span class="button-prev"></span>','<span class="button-next"></span>']}),jQuery(".sb-product-carousel").length&&jQuery(".sb-product-carousel").owlCarousel({autoplay:!0,loop:!0,nav:!1,dots:!1,items:1}),jQuery(".sb-banner-list").length&&jQuery(".sb-banner-list").owlCarousel({nav:!1,dots:!0,items:1}),jQuery(".sb-product-grid").length&&jQuery(".sb-product-grid").owlCarousel({nav:!0,dots:!1,items:1,navText:['<span class="button-prev"></span>','<span class="button-next"></span>']}),jQuery(".aticle-image-slider").length&&jQuery(".aticle-image-slider").owlCarousel({nav:!1,dots:!0,items:1}),jQuery(".sb-blog-grid").length&&jQuery(".sb-blog-grid").owlCarousel({nav:!0,dots:!1,items:1,navText:['<span class="button-prev"></span>','<span class="button-next"></span>']})},init:function(){this.owlSlider()}},bcMsieVersion={MsieVersion:function(){var s=window.navigator.userAgent,e=s.indexOf("MSIE ");return e>0||navigator.userAgent.match(/Trident.*rv\:11\./)?parseInt(s.substring(e+5,s.indexOf(".",e))):0},init:function(){this.MsieVersion()}};
jQuery.fn.extend({scrollToMe:function(){if(jQuery(this).length){var e=jQuery(this).offset().top-200;jQuery("html,body").animate({scrollTop:e},500)}}});
function addCart(){AT_Main.fixNoScroll(),$(".cart-sb").toggleClass("opened"),$("html,body").toggleClass("cart-opened")}function notifyAddCartFail(o){$.jGrowl(o,{life:3e3,position:"center"})}
function addToCart(a){void 0!==a&&a.preventDefault();var d=$(this);d.addClass("disabled");var e=d.parents("form");$(".modal").modal("hide"),$.ajax({type:"POST",url:"/cart/add.js",async:!0,data:e.serialize(),dataType:"json",error:addToCartFail,success:addToCartSuccess,cache:!1})};
function addToCartSuccess (jqXHR, textStatus, errorThrown){
  $('.add-to-cart').removeClass('disabled');
  $.ajax({
    type: 'GET',
    url: '/cart.js',
    async: false,
    cache: false,
    dataType: 'json',
    success: updateCartDesc
  });
  
    $('#layer-addcart-modal').show();
    var price = jqXHR['price'];
    var qty = jqXHR['quantity'];
    var total = price * qty;
    var addcart_modal_image = '<img src="'+ Shopify.resizeImage(jqXHR['image'], 'small') +'" alt="'+ jqXHR['title'] +'"/>';
    var addcart_modal_name = jqXHR['product_title'];
    var addcart_modal_variant = ""; if(jqXHR['variant_title'] != null) addcart_modal_variant = 'Variant: '+jqXHR['variant_title'];
    var addcart_modal_qty = '<strong>Qty:</strong>'+jqXHR['quantity'];
    var addcart_modal_price = '<strong>Total:</strong>'+Shopify.formatMoney(total, _bc_config.money_format);
    var addcart_modal_numpro = ""; if ($(".basket .number .n-item").html() == 1) addcart_modal_numpro = "There is 1 item in your cart."; else addcart_modal_numpro = "There are "+$(".basket .number .n-item").html()+" items in your cart.";

    //add data

    $('.addcart-modal-image').html(addcart_modal_image);
    $('.addcart-modal-title').html(addcart_modal_name);
    $('.addcart-modal-price').html(addcart_modal_price);
    $('.addcart-modal-variant').html(addcart_modal_variant); 
    $('.addcart-modal-qty').html(addcart_modal_qty);
    $('.addcart-modal-number').html(addcart_modal_numpro);
    $('.addcart-modal-box').show();
  
  

  // Get the cart show in the cart box.
  Shopify.getCart(function(cart) {
    Shopify.updateCartInfo(cart, '#cart-info #cart-content');		
  });
  
  
}

function addToCartFail(jqXHR, textStatus, errorThrown){
  var response = $.parseJSON(jqXHR.responseText);

  var $i = '<div class="error">'+ response.description +'</div>';
  notifyAddCartFail($i);
  $this.removeClass('disabled');
}

function addcartModalHide(){
  $("#layer-addcart-modal").addClass("zoomOut animated").fadeOut();
  $("#layer-addcart-modal").removeClass("zoomOut animated");
}

jQuery(document).ready(function($) {
  
  AT_Slider.init();
  
  
    $("body").on( 'click','.add-to-cart', addToCart );
  
  
})
// jQuery(document).ready(function($) {
//   if (($(window).width() < 1025) && ($(window).width() > 991)){
//     $('.main_drop_menu').click(function(){
//       //$('.main_drop_menu').click(function(){
//           var h = $(this).find('.dropdown-link').attr('href');
//           console.log('https://www.stonepavingdirect.co.uk/'+h);
//           window.location.href = h ;

//          // });
//     });
//    }    
// });


// jQuery(document).ready(function($) {
//   if (($(window).width() < 1025) && ($(window).width() > 991)){
//     $('.dropdown-link a').click(function(event){
//       event.preventDefault();
//     });
//     $('.dropdown-link a span').click(function(event){
//       $(this).parent('a').unbind("click");
//       var hatt= $(this).parent('a').attr('href');
//       console.log(hatt);
//       console.log('click');
      
//     });
//   }
// });